import { ListItem, Skeleton, styled, Typography } from '@mui/material';

export const DetailsLabel = styled(Typography)({
  width: '30%',
});

const DetailsListItemRoot = styled(ListItem)({
  alignItems: 'center',
  justifyContent: 'space-between',
});

export function DetailsListItem({
  label,
  value,
  loading,
}: {
  label: React.ReactNode;
  value: React.ReactNode;
  loading?: boolean;
}) {
  return (
    <DetailsListItemRoot>
      <DetailsLabel variant="body1">{label}</DetailsLabel>
      <Typography variant="body1" component="div">
        {loading ? <Skeleton /> : value}
      </Typography>
    </DetailsListItemRoot>
  );
}
